import type {z} from "zod";

import {AddLeadNoteBody} from "@project/sdk/sales/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const addLeadNoteTitleSchema = requiredStringSchema(
  AddLeadNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const addLeadNoteContentSchema = requiredStringSchema(
  AddLeadNoteBody.shape.content,
  noteFieldLabelIds.content,
);

export const addLeadNoteFormSchema = AddLeadNoteBody.extend({
  title: addLeadNoteTitleSchema,
  content: addLeadNoteContentSchema,
});
export type AddLeadNoteFormPayload = z.output<typeof addLeadNoteFormSchema>;

export const draftAddLeadNoteFormSchema = addLeadNoteFormSchema.partial();
export type DraftAddLeadNoteFormPayload = z.output<typeof draftAddLeadNoteFormSchema>;
